export const TEXTS = {
  OFERTA_TITLE: 'При регистрации вы соглашаетесь с ',
  OFERTA_LINK: 'условиями публичной оферты',
  COOKIE_POLICY_TITLE: ' и подтверждаете, что ознакомились с ',
  COOKIE_POLICY_LINK: 'Политикой в отношении обработки файлов cookie',
  DELIMITER_TEXT: 'Зарегистрироваться с помощью',
  BUTTON_SBBID_TITLE: 'Войти по СберБизнес ID',
  REGISTRATION_ORGANIZATION_TYPE_TITLE: 'Тип организации',
  REGISTRATION_ORGANIZATION_TYPE_LEGAL: 'Юридическое лицо или ИП',
  REGISTRATION_ORGANIZATION_TYPE_SELF_EMPLOYED: 'Самозанятый',
};
